import * as React from "react";
import { connect } from "react-redux";

import Brand from "../../screens/Settings/Brand/Brand";
import {
  fetchBrands,
  AddBrand,
  EditBrand,
  DeleteBrand,
  brandSlectedPage,
  ItemBrandInActive
} from "./action";
class BrandContainer extends React.Component<Props, State> {
  render() {
    return (
      <Brand
        fetchBrands={this.props.fetchBrands}
        BrandList={this.props.BrandList}
        AddBrand={this.props.AddBrand}
        EditBrand={this.props.EditBrand}
        DeleteBrand={this.props.DeleteBrand}
        brandSlectedPage={this.props.brandSlectedPage}
        BrandCount={this.props.BrandCount}
        ItemBrandInActive={this.props.ItemBrandInActive}
      />
    );
  }
}
function bindAction(dispatch) {
  return {
    fetchBrands: () => {
      dispatch(fetchBrands());
    },
    AddBrand: value => {
      // console.log(value);
      dispatch(AddBrand(value));
    },
    EditBrand: value => {
      dispatch(EditBrand(value));
    },
    DeleteBrand: value => {
      dispatch(DeleteBrand(value));
    },
    brandSlectedPage: value => {
      dispatch(brandSlectedPage(value));
    },
    ItemBrandInActive:value =>{
      dispatch(ItemBrandInActive(value));
    }
  };
}
const mapStateToProps = state => {
  return {
    BrandList: state.BrandReducer.BrandList,
    BrandCount: state.BrandReducer.BrandCount
  };
};

export default connect(
  mapStateToProps,
  bindAction
)(BrandContainer);
